module.exports = __webpack_public_path__ + "static/media/IMG_019.e65e8597.JPG";